import { LayoutGrid, Briefcase, MessageCircle } from "lucide-react";
import { CONTACT } from "../data/site";

export const MobileBar = () => (
  <nav data-testid="mobile-bottom-bar" className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/85 backdrop-blur-xl border-t border-black/10 grid grid-cols-3">
    <a href="#work" data-testid="mobile-bar-work" className="flex flex-col items-center gap-1 py-2.5 text-black/60 active:text-[#0047FF]">
      <LayoutGrid size={20} />
      <span className="text-[11px] font-bold font-display">Work</span>
    </a>
    <a href="#services" data-testid="mobile-bar-services" className="flex flex-col items-center gap-1 py-2.5 text-black/60 active:text-[#0047FF]">
      <Briefcase size={20} />
      <span className="text-[11px] font-bold font-display">Services</span>
    </a>
    <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="mobile-bar-message" className="flex flex-col items-center gap-1 py-2.5 text-[#0047FF]">
      <MessageCircle size={20} />
      <span className="text-[11px] font-bold font-display">Message</span>
    </a>
  </nav>
);
